<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="client.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
        </div>

        <div class="field">
          <label class="font-medium">Контрагенты</label>
          <crm-contragent-multi-select
            [(selectedContragents)]="client.contragents"
            [isError]="$any(errors?.contragents)"
            appendTo="body"></crm-contragent-multi-select>
          <small
            *ngIf="errors?.contragents"
            class="p-error">
            {{ errors.contragents | join }}
          </small>
        </div>

        <div
          *ngIf="isHelpdeskAvailable"
          class="field">
          <label class="font-medium">Типы заявок HelpDesk</label>
          <crm-hd-task-type-multi-select
            [customRequest]="true"
            [isFloatLabel]="false"
            [taskTypes]="helpdeskTaskTypes"
            [(selectedTaskTypes)]="client.helpdeskTaskTypes"
            [styleClass]="errors?.helpdeskTaskTypes ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.helpdeskTaskTypes ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-hd-task-type-multi-select>
          <small
            *ngIf="errors?.helpdeskTaskTypes"
            class="p-error">
            {{ errors?.helpdeskTaskTypes | join }}
          </small>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveClient()"></button>
      <ng-container *ngIf="(form$ | async)?.isEdit">
        <button
          *ngIf="!client['deleted'] && globalService.isAccessRule('BASIS:CLIENT:CAN_DELETE_CLIENTS')"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteClient()"></button>

        <button
          *ngIf="client['deleted']"
          pButton
          label="Восстановить"
          class="p-button-text"
          (click)="unlockClient()"></button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
